import styles from "./Contact.module.css";

import { getImageURL } from "../../utils";

function Contact() {
    return (
        <footer id="contact" className={styles.container}>
            <div className={styles.content}>
                <h1>Contact</h1>
                <p>Feel free to reach out!</p>
            </div>
            <ul className={styles.links}>
                <li className={styles.link}>
                    <img src={"/logo192.png"} alt="Email icon" />
                    {/*<img src={getImageURL("contact/emailIcon.png")} alt="Email icon" />*/}
                    <a href="mailto:lmhoang22@apcs.fitus.edu.vn">lmhoang22@apcs.fitus.edu.vn</a>
                </li>
                <li className={styles.link}>
                    <img src={"/logo192.png"} alt="Email icon" />
                    {/*<img src={getImageURL("contact/githubIcon.png")} alt="Github icon" />*/}
                    <a href="https://github.com/monarchuwu">github.com/monarchuwu</a>
                </li>
            </ul>
        </footer>
    );
}

export default Contact;